export default "__VITE_ASSET__CWrz8x0I__"